const Gavel = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='17'
    height='18'
    viewBox='0 0 17 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.11523 2.87038L9.23623 0.748779L13.4794 4.99078L11.3584 7.11238L7.11523 2.87038ZM3.93799 6.05153L6.06049 3.93143L16.661 14.5439L14.5385 16.664L3.93799 6.05153ZM2.8713 7.11468L0.75 9.23598L4.9926 13.4786L7.1139 11.3573L2.8713 7.11468ZM0.750977 15.75H9.75098V17.25H0.750977V15.75Z'
      fill='currentColor'
    />
  </svg>
);

export default Gavel;
